var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**ONBOARDING**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thankyou",
    transform: "translate(-670.000000, -309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(670.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#9BCAF7",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#5DA9F0",
    cx: 50,
    cy: 50,
    r: 43.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#3995EF",
    cx: 50,
    cy: 50,
    r: 38.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8623047,38.4082031 C69.3180361,38.8639346 69.5458984,39.4173145 69.5458984,40.0683594 C69.5458984,40.7194043 69.3180361,41.2727842 68.8623047,41.7285156 L47.8662109,62.7246094 C47.4104795,63.1803408 46.8570996,63.4082031 46.2060547,63.4082031 C45.5550098,63.4082031 45.0016299,63.1803408 44.5458984,62.7246094 L32.3876953,50.5664062 C31.9319639,50.1106748 31.7041016,49.5572949 31.7041016,48.90625 C31.7041016,48.2552051 31.9319639,47.7018252 32.3876953,47.2460938 L35.7080078,43.9257812 C36.1637393,43.4700498 36.7171191,43.2421875 37.3681641,43.2421875 C38.019209,43.2421875 38.5725889,43.4700498 39.0283203,43.9257812 L46.2060547,51.1279297 L62.2216797,35.0878906 C62.6774111,34.6321592 63.230791,34.4042969 63.8818359,34.4042969 C64.5328809,34.4042969 65.0862607,34.6321592 65.5419922,35.0878906 L68.8623047,38.4082031 Z",
    id: "\\uF00C",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/checkSuccess.ad4c8093a81f3ef7f12c11e8a7b50a2e.svg";
export { ForwardRef as ReactComponent };